import { useCallback } from "react";
import type { Task } from "@common/types/task";
import type { TaskDetailSectionRequest } from "./TaskDetail/constants";
import { showTaskSection } from "./showTaskSection";
import { useTaskRowActions } from "./tasks.context";

/**
 * Opens a task with `onOpenTask`, unless it's already open (a card click
 * would close it), then shows `section` in the expanded right sidebar.
 * Board cards, List's blocked badge and List's row actions open sections
 * this way.
 */
export const useOpenTaskSection = (
    onOpenTask: (task: Task) => void,
    section: "chat" | TaskDetailSectionRequest,
) => {
    const rowActions = useTaskRowActions();
    return useCallback(
        (task: Task) => {
            if (rowActions?.getSelectedTaskId() !== task.id) {
                onOpenTask(task);
            }
            if (rowActions !== null) {
                showTaskSection({ ...rowActions, section, taskId: task.id });
            }
        },
        [onOpenTask, section, rowActions],
    );
};
